import { Rates } from "../../api/AlqemiDataService";

export const HOURLY_RATE_PLACEHOLDER = "{hourly_rate}";
export const HOURLY_RATE_FALLBACK_EN = "TBD after consultation";
export const HOURLY_RATE_FALLBACK_DE = "nach Absprache";

// "Stundensatz" only appears in our German templates; cheap, unambiguous signal.
const isGermanEmail = (emailContent: string): boolean =>
  emailContent.includes("Stundensatz");

export function substituteHourlyRate(
  emailContent: string,
  rates: Rates | undefined | null,
): string {
  if (!emailContent || !emailContent.includes(HOURLY_RATE_PLACEHOLDER)) {
    return emailContent;
  }

  const rate = rates?.rate ?? 0;
  const lower = rates?.lower_band ?? 0;
  const upper = rates?.upper_band ?? 0;

  let replacement: string;
  if (rate > 0) {
    replacement =
      lower > 0 && upper > 0
        ? `€${lower}-€${upper}/hour remote`
        : `€${rate}/hour remote`;
  } else {
    replacement = isGermanEmail(emailContent)
      ? HOURLY_RATE_FALLBACK_DE
      : HOURLY_RATE_FALLBACK_EN;
  }

  return emailContent.split(HOURLY_RATE_PLACEHOLDER).join(replacement);
}
